module.exports = __webpack_public_path__ + "img/smiling_face_with_hearts.552b80d7.gif";